import { Theme } from '@material-ui/core/styles/createTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { EdwardColors } from 'enums';
import { borderRadiusBox } from 'components/AppTheme/index';

interface StyleProps {
  detailMode?: boolean;
  indPortfolio?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background: theme.palette.background.paper,
      padding: theme.spacing(2),
      marginBottom: theme.spacing(2),
      maxWidth: '100vw',
    },
    tabsSection: {
      position: 'relative',
      boxShadow: `0px 4px 5px 0px rgba(0,0,0,0.2), 0px 3px 1px 0px rgba(0,0,0,0.14), 0px 5px 1px -2px rgba(0,0,0,0.12)`, // shadow[2] without top
    },
    sectionHeadings: {
      marginBottom: 0,
    },
    flexRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    portfolioTable: {
      padding: theme.spacing(3),
    },
    currency: {
      width: '100px',
    },
    chartArea: {
      paddingTop: theme.spacing(2),
      justifyContent: 'space-between',
    },
    switches: {
      alignSelf: 'center',
      '& label': {
        justifyContent: 'flex-end',
      },
    },
    switch: {
      margin: theme.spacing(2),
    },
    planControlButtons: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& > div > div': {
        marginTop: 0,
      },
    },
    pieWrapper: {
      width: '100%',
    },
    esgSelect: {
      order: 1,
    },
    esg: (props: StyleProps) => ({
      order: 2,
      zIndex: 1,
      '& > div > div > svg': { width: '64px', height: '64px' },
      '& img': { height: '64px' },
      '& > div': {
        position: 'absolute',
        right: theme.spacing(3),
        top: theme.spacing(props.indPortfolio ? 12 : 2),
        width: '320px',
        fontWeight: 'bold',
        color: EdwardColors.GREEN,
        '& > div': {
          '& > span': {
            position: 'relative',
            '& > span': {
              position: 'absolute',
              right: `-${theme.spacing(4)}px`,
              top: '50%',
              transform: 'translate(0,-50%)',
            },
          },
          paddingRight: theme.spacing(4),
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          '&.blackrock': {
            fontSize: '12px',
            fontWeight: 'normal',
            color: 'black',
            textAlign: 'right',
          },
        },
      },
      [`@media (max-width:${props.detailMode ? '1410' : '1024'}px)`]: {
        width: '100%',
        maxWidth: '100%',
        flexBasis: '100%',
        order: 3,
        '& > div': {
          position: 'relative',
          left: 0,
          top: 0,
          margin: '0 auto',
        },
      },
    }),

    tabs: {
      height: theme.spacing(8),
      display: 'flex',
      marginBottom: '-8px',

      '& > div': {
        height: '100%',
        transform: 'translateY(5%)',
        transition: 'transform 0.2s',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 4),
        background: theme.palette.grey['200'],
        cursor: 'pointer',
        '&:after': {
          content: '""',
          display: 'block',
          width: 'calc(100% + 0px)',
          height: '14px',
          position: 'absolute',
          left: '-0px',
          bottom: '-11px',
          background: theme.palette.common.white,
        },
        '&:first-child:after': {
          left: 0
        },
        '&.activeTab': {
          transform: 'translateY(-10%)',
          borderTopLeftRadius: borderRadiusBox,
          borderTopRightRadius: borderRadiusBox,
          zIndex: 1,
          background: theme.palette.common.white,
          boxShadow: '0 0 10px 1px rgba(0,0,0,0.13)',
          '&:after': {
            zIndex: 1,
          },
        },
      },

      [theme.breakpoints.down('xs')]: {
        //height: theme.spacing(12),
        '& > div': { padding: theme.spacing(0, 2), }
      },
      '@media (max-width:450px)': {
        '& > div': { padding: theme.spacing(0, 1), }
      },

    },
    chart: (props: StyleProps) => ({
      marginBottom: theme.spacing(10),
      order: 3,
      [`@media (max-width:${props.detailMode ? '1410' : '1024'}px)`]: { order: 2 },
    }),
    table: (props: StyleProps) => ({
      order: 4,
      [`@media (max-width:${props.detailMode ? '1410' : '1024'}px)`]: { paddingTop: theme.spacing(2) },
    }),
    editPortfolio: {
      '@media (max-width:1023px)': {
        display: 'none',
      },
    },
    bucketMisc: {
      maxWidth: '825px',
      minWidth: '825px',
      margin: '0 auto 16px auto',
      [`@media (max-width: 1200px)`]: {
        minWidth: 'auto',
        padding: '0 8px',
      },
      [theme.breakpoints.down('xs')]: {
        '& > div': {
          textAlign: 'center !important',
          margin: '8px 0'
        }
      },
    },
    drift: {
      fontSize: '20px',
      fontWeight: 800,
      '& > span': { marginLeft: theme.spacing(1) },
      '& .HIGH': { color: EdwardColors.ALERT },
      '& .MID': { color: EdwardColors.DARK },
      '& .LOW': { color: EdwardColors.GREEN },
    }
  }),
);

export default useStyles;
